import type { FormatGroup, SpreadTemplate } from "./types";
import { THEME_TEMPLATES } from "./themes";
import { SPREADS_A4_PORTRAIT } from "./formats/a4_portrait";
import { SPREADS_A4_LANDSCAPE } from "./formats/a4_landscape";
import { SPREADS_A5_PORTRAIT } from "./formats/a5_portrait";
import { SPREADS_A5_LANDSCAPE } from "./formats/a5_landscape";

// English comment: Spread library mapped by format group (manager-driven)
const SPREADS_BY_FORMAT: Record<FormatGroup, SpreadTemplate[]> = {
  a4_portrait: SPREADS_A4_PORTRAIT,
  a4_landscape: SPREADS_A4_LANDSCAPE,
  a5_portrait: SPREADS_A5_PORTRAIT,
  a5_landscape: SPREADS_A5_LANDSCAPE
};

export function getSpreadTemplates(formatGroup: FormatGroup) {
  return SPREADS_BY_FORMAT[formatGroup] || [];
}

export { THEME_TEMPLATES };
